import { 
  EXTRACT_URL,
  CLEAR_CLIPPER,
  SET_CLIPPER_URL,
} from '../actions'

import { Map } from 'immutable'

export default function clipper(state = {

}, action) {
  switch (action.type) {
    case EXTRACT_URL:
      return { ...state, extract: action.error ? Map(action.payload).set('error', action.error) : Map(action.payload) }
    case CLEAR_CLIPPER:
      return { ...state, extract: null }
    default:
      return state
  }
}
